import { Fragment } from 'react';
import type { GetAllPostTitles } from '@api';
import { postPath } from '@paths';
import { addTrailingSlash } from '@utils';

export const SimplePostList: React.FC<{
  simplePosts: Awaited<GetAllPostTitles>;
}> = ({ simplePosts }) => (
  <section>
    <div className='mb-16 columns-2 md:mb-32'>
      {simplePosts.map((post, i) => (
        <Fragment key={post.slug || i}>
          {post.slug ? (
            <a
              href={addTrailingSlash(postPath(post.slug))}
              className='mb-1 block text-primary underline hover:text-top-primary'
            >
              {post.title}
            </a>
          ) : (
            <></>
          )}
        </Fragment>
      ))}
    </div>
  </section>
);
